import React, { useLayoutEffect } from 'react';
import { setConstraints } from '../../store/birdLayout/BirdLayoutState';
import { TextState } from '../../store/birdElement/textState';
import { connect } from 'react-redux';
import { selectBirdRichTextState } from '../../store/selectors';
import { bindActionCreators } from 'redux';
import { renderInlineCssVars, useDesignTokens } from '@sas/nova-commons/theme';
//css
import cn from './BirdText.css.json';
import './BirdText.css';
/**
 * Links inserted into rich text in VA have an href that starts with "ac" followed by a number.
 */
const linkPattern = /^ac\d+$/;
export const BirdTextBase = function ({ actions, state, id }) {
    const dt = useDesignTokens();
    const { text: __html = '' } = state;
    useLayoutEffect(() => {
        actions.setConstraints(id, {
            minWidth: 100,
        });
    }, [actions, id]);
    return (React.createElement("div", { style: renderInlineCssVars({ 'font-size': dt.reportTokens.font.size.m }, 'text'), className: cn.text, tabIndex: 0, onClick: (e) => {
            // Handle delegated click events on <a> elements in the rich text.
            // NOTE: this event handler also handles "Enter" key when the anchor is focused.
            if (!(e.target instanceof HTMLAnchorElement))
                return;
            // VAV used to regex replace href attributes with "#" and set a data attribute.
            // Reading from the href attribute (not property) avoids needing to process the html
            // from portable.
            //
            // FIXME: both approaches have an a11y issue. The <a> element from portable should probably
            //      | have a valid href attribute if it's supposed to open an external link. VA does this.
            const interactionId = e.target.getAttribute('href');
            if (interactionId !== null && linkPattern.test(interactionId)) {
                actions.notifyInteraction(id, interactionId);
                e.preventDefault();
            }
        }, onDoubleClick: () => {
            actions.notifyDoubleClick(id);
        }, dangerouslySetInnerHTML: { __html } }));
};
export const BirdText = connect((state, props) => ({
    state: selectBirdRichTextState(state, props.id),
}), (dispatch) => ({
    actions: bindActionCreators(Object.assign({ setConstraints }, TextState.actions), dispatch),
}))(BirdTextBase);
